module.exports = __webpack_public_path__ + "img/searchList.cecd33bc.svg";